// Web mock for react-native-linear-gradient using CSS gradients
import React from 'react';
import { View } from 'react-native';

interface LinearGradientProps {
  colors: string[];
  start?: { x: number; y: number };
  end?: { x: number; y: number };
  locations?: number[];
  style?: any;
  children?: React.ReactNode;
}

const LinearGradient: React.FC<LinearGradientProps> = ({
  colors,
  start = { x: 0, y: 0 },
  end = { x: 0, y: 1 },
  locations,
  style,
  children,
}) => {
  // Calculate angle from start/end points
  const angle = Math.atan2(end.y - start.y, end.x - start.x) * (180 / Math.PI) + 90;

  // Build color stops
  let colorStops: string;
  if (locations && locations.length === colors.length) {
    colorStops = colors
      .map((color, i) => `${color} ${locations[i] * 100}%`)
      .join(', ');
  } else {
    colorStops = colors.join(', ');
  }

  const backgroundImage = `linear-gradient(${angle}deg, ${colorStops})`;

  return (
    <View
      style={[
        style,
        { backgroundImage } as any,
      ]}
    >
      {children}
    </View>
  );
};

export default LinearGradient;
